module.exports = __webpack_public_path__ + "img/33_29.01d03961.png";